<template>
  <div class="breadcrumb-container px-3">
    <h6 v-if="headText">
      {{ headText }}
    </h6>
    <b-breadcrumb>
      <b-breadcrumb-item
        v-for="item in breadcrumbItems"
        :active="item.active"
        :to="item.to"
      >
        <b-icon
          icon="house"
          v-if="item.to === '/' || (item.name && item.name === 'root')"
        ></b-icon>
        {{ item.text }}
      </b-breadcrumb-item>
    </b-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbItems: {
      type: Array,
      default: [],
    },
    headText: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.primaryColorLighter {
  background: $color-white;
  padding: 15px 0;
  margin-bottom: 18px;
  border-top-left-radius: 20px;
}
h6 {
  font-size: 20px;
  color: $primaryColor;
}
:deep {
  .breadcrumb-item + .breadcrumb-item {
    position: relative;
    padding: 0 20px 0 0;
  }
  .breadcrumb-item a {
    color: $primaryColor;
    font-weight: 500;
  }
  .breadcrumb-item.active span {
    color: $secondaryColor;
    font-weight: 500;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    content: url(@/assets/icons/white-left-arrow.svg);
    color: $primaryColor;
    position: absolute;
    right: -1px;
    transform: translateY(3px);
  }
}
</style>
